module.exports = __webpack_public_path__ + "static/highlight_2.e10ae8a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/_images/highlight_2.png
// module id = 488
// module chunks = 35783957827783